import _ from 'lodash';
import { gql } from '@apollo/client';
import useYearMasters from '../components/useYearMaster';

class Report {
  constructor({ title, onEditClick, name }) {
    this.name = name;
    this.query = gql`
      query report {
        request {
          id
          employee {
            id
            reports {
              ${name}
              ${name}Url
            }
          }
        }
      }
    `;
    this.title = title;
    this.show = async ({ client, show, setPdf, notify, ...rest }) => {
      show({ title, onEditClick, ...rest });
      try {
        const data = await client.query({
          query: this.query,
          fetchPolicy: 'no-cache',
          errorPolicy: 'all'
        });
        const reports = data.data.request?.employee?.reports;
        if (data.errors) {
          if (data.errors[0].extensions?.code === 'NOT_EXIST_OFFICE') {
            return notify(data.errors[0].message + '  管理者にお問い合わせください。', 'error');
          } else {
            return notify(data.errors[0].message, 'error');
          }
        }
        setPdf(reports[this.name], reports[`${this.name}Url`]);
      } catch (error) {
        const msg = _.get(error, 'graphQLErrors[0].message');
        notify(msg || error.message, 'error');
      }
    };
  }
}

export const Reports = ({ year, children }) => {
  const [yearMaster] = useYearMasters({
    year,
    toJpFirstYear: true
  });
  const yearMastersOfR = useYearMasters({
    year,
    toHeiseiEra: true,
    toJpFirstYear: true
  });
  if (!yearMaster || _.isEmpty(yearMastersOfR)) return null;
  const [thisYear, nextYear] = yearMastersOfR;
  const reports = [
    ['withholdingSlip', '源泉徴収票'],
    ['insuranceDeduction', `${yearMaster.eraName}${yearMaster.eraNumber}年分 給与所得者の保険料控除申告書`],
    ['spouseDeduction', `${yearMaster.eraName}${yearMaster.eraNumber}年分 給与所得者の配偶者控除等申告書`, true],
    [
      'bsiDeduction',
      `${yearMaster.eraName}${yearMaster.eraNumber}年分 給与所得者の基礎控除申告書 兼 給与所得者の配偶者控除等申告書 兼 所得金額調整控除申告書`,
      true
    ],
    ['dependentDeductionThisYear', `${thisYear.eraName}${thisYear.eraNumber}年分 給与所得者の扶養控除等（異動）申告書`],
    ['dependentDeductionNextYear', `${nextYear.eraName}${nextYear.eraNumber}年分 給与所得者の扶養控除等（異動）申告書`],
    ['fileMount', '添付書類台紙']
  ].reduce((obj, [name, title], hasMyNumber) => {
    obj[name] = new Report({ name, title });
    return obj;
  }, {});
  return children(reports);
};

export default Reports;
